import { Component, OnInit, Input } from '@angular/core';
import { NavegacionService } from '../sidenav.service';
import { Router } from '@angular/router';
import { UserService } from '../shared/user.service';
import { User } from '../shared/user.model';
import { DiagnosticoCliente } from '../diagnostico/Diagnostico.entity';

@Component({
  selector: 'app-menurecursos',
  templateUrl: './menurecursos.component.html',
  styleUrls: ['./menurecursos.component.css'] // ../../assets/scss/tool-styles.scss
})
export class MenurecursosComponent implements OnInit {
// <a  routerLink="/account" routerLinkActive="activo" >Editar mis datos</a>

  currentDiagnostico: DiagnosticoCliente;
  @Input() fixed = false;
  userClaims: any;
  public currentClient: User;
  sidebarhide = true;
  helpclick = false;
  constructor(public navegacionServices: NavegacionService,
    private router: Router, private userService: UserService ) { }

  Logout() {
    this.navegacionServices.currentDimension = null;
    this.navegacionServices.currentEtapa = null;
    this.navegacionServices.currentClient = null;
    localStorage.removeItem('userToken');
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    this.getInitialData();
  }
  public getInitialData() {
    this.currentClient = this.navegacionServices.currentClient;
    if ( ! this.fixed) {
    this.currentDiagnostico = this.navegacionServices.currentDiag;
    }
  }

  MenuClick() {}

  /* <div class="topbar__help topbar__help-close ">
  <a  id="open-help">
    Ayuda
    <img src="../assets/img/help-icon.svg" alt="">
  </a>
  <a  id="close-help">
    Cerrar ayuda
    <img src="../assets/img/help-close-icon.svg" alt="">
  </a>
</div> */
}



// WEBPACK FOOTER //
// ./src/app/menurecursos/menurecursos.component.ts